import { apiURL, axiosInstance } from 'constants/config';
import {
  loadPapersRequested,
  loadPapersFail,
  loadPapersSuccess,
  storeAssignPaperRequested,
  storeAssignPaperSuccess,
  storeAssignPaperFail,
  storePaperRequested,
  storePaperSuccess,
  storePaperFail,
  updatePaperRequested,
  updatePaperSuccess,
  updatePaperFail,
  loadAssignPaperRequested,
  loadAssignPaperSuccess,
  loadAssignPaperFail,
  updateAssignPaperRequested,
  updateAssignPaperSuccess,
  updateAssignPaperFail,
  deletePaperRequested,
  deletePaperSuccess,
  deletePaperFail,
  deleteAssignPaperRequested,
  deleteAssignPaperSuccess,
  deleteAssignPaperFail,
  loadPapersListRequested,
  loadPapersListSuccess,
  loadPapersListFail,
  loadWeekdaysRequested,
  loadWeekdaysSuccess,
  loadWeekdaysFail,
  loadPaperWeekdaysRequested,
  loadPaperWeekdaysSuccess,
  loadPaperWeekdaysFail,
} from './papersSlice';
import { put, call, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { loadCustomerEffect } from 'store/customers/sagas';
import {
  loadBillInfoEffect,
  loadPaymentBillEffect,
} from 'store/payments/sagas';

export function* loadPapersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/papers?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action.payload?.page
      }&PaginationOption.PageSize=${action.payload?.perPage}`
    );
    yield put(loadPapersSuccess(data));
  } catch (error: any) {
    yield put(loadPapersFail(error.meessage));
  }
}

export function* loadPapersListEffect(): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/papers/list`);
    yield put(loadPapersListSuccess(data));
  } catch (error: any) {
    yield put(loadPapersListFail(error.meessage));
  }
}

export function* storePaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/papers`,
      action.payload?.values
    );
    if (data?.succeeded) {
      yield put(storePaperSuccess(data));
      toast.success('Paper created successfully');
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(storePaperFail(error.message));
  }
}

export function* updatePaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/papers/${action.payload?.id}`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updatePaperSuccess(data));

      yield call(loadPapersEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: '',
      });

      toast.success('Paper updated successfully');
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(updatePaperFail(error.message));
  }
}
export function* deletePaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { item } = action.payload;

    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/papers/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(deletePaperSuccess(data));
      toast.success('Paper deleted successfully');
      // yield call(loadPapersEffect, {
      //   payload: { filters: {}, perPage: 10, page: 1 },
      //   type: '',
      // });
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(deletePaperFail(error.message));
  }
}

export function* loadAssignPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/papers/users/${
        action?.payload?.filters?.reference ?? ''
      }?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action.payload.page
      }&PaginationOption.PageSize=${action.payload.perPage}`
    );

    yield put(loadAssignPaperSuccess(data));
  } catch (error: any) {
    yield put(loadAssignPaperFail(error.meessage));
  }
}

export function* storeAssignPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/customers/assign/papers`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeAssignPaperSuccess(data));
      yield call(loadAssignPaperEffect, {
        payload: {
          filters: { reference: action?.payload?.customerReference, query: '' },
          page: 1,
          perPage: 10,
        },
        type: 'loadPapersAfterAssign',
      });
      yield call(loadCustomerEffect, {
        payload: { reference: action?.payload?.customerReference },
        type: '',
      });
      yield call(loadBillInfoEffect, {
        payload: action?.payload?.customerReference,
        type: '',
      });

      toast.success('Paper assigned successfully.');
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(storeAssignPaperFail(error.message));
  }
}

export function* updateAssignPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/customers/assign/papers/${action.payload?.id}`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateAssignPaperSuccess(data));

      yield call(storeAssignPaperEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: '',
      });

      yield call(loadAssignPaperEffect, {
        payload: {
          filters: { reference: action?.payload?.customerReference, query: '' },
          page: 1,
          perPage: 10,
        },
        type: 'loadPapersAfterAssign',
      });
      toast.success('Assigned paper updated successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updateAssignPaperFail(error.message));
  }
}

export function* deleteAssignPaperEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/customers/assign/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(deleteAssignPaperSuccess(data));
      yield call(loadAssignPaperEffect, {
        payload: {
          filters: {
            reference: action?.payload?.item?.reference,
            query: '',
          },
          page: 1,
          perPage: 10,
        },
        type: 'loadPapersAfterAssign',
      });
      toast.success('Assigned paper deleted successfully');
    }
  } catch (error: any) {
    yield put(deleteAssignPaperFail(error.message));
  }
}

export function* loadWeekdaysEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/weekdays`);
    if (data.succeeded) {
      yield put(loadWeekdaysSuccess(data));
    }
  } catch (error: any) {
    yield put(loadWeekdaysFail(error.message));
  }
}

export function* loadPaperWeekdaysEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/papers/weekdays/${action.payload}`
    );
    if (data.succeeded) {
      yield put(loadPaperWeekdaysSuccess(data));
    }
  } catch (error: any) {
    yield put(loadPaperWeekdaysFail(error.message));
  }
}

export function* papersSaga(): Generator<any, void, any> {
  yield takeEvery(storePaperRequested, storePaperEffect);
  yield takeEvery(storeAssignPaperRequested, storeAssignPaperEffect);
  yield takeEvery(loadPapersRequested, loadPapersEffect);
  yield takeEvery(loadPapersListRequested, loadPapersListEffect);
  yield takeEvery(loadAssignPaperRequested, loadAssignPaperEffect);
  yield takeEvery(updatePaperRequested, updatePaperEffect);
  yield takeEvery(updateAssignPaperRequested, updateAssignPaperEffect);
  yield takeEvery(deletePaperRequested, deletePaperEffect);
  yield takeEvery(deleteAssignPaperRequested, deleteAssignPaperEffect);
  yield takeEvery(loadWeekdaysRequested, loadWeekdaysEffect);
  yield takeEvery(loadPaperWeekdaysRequested, loadPaperWeekdaysEffect);
}
